import { render } from "./FlaticonsContent.vue?vue&type=template&id=571a4771"
import script from "./FlaticonsContent.vue?vue&type=script&lang=js"
export * from "./FlaticonsContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__